import React, { Component } from 'react';
import { connect } from "react-redux";
import { updateHighlightedDriver, clearHighlightedDriver, updateDriverFilter } from '../../data/actions/drivers';
import driverUtils from '../../../script/utils/driver';
import Driver from './driver';
import './drivers-list.css';

class DriversList extends Component {

    render() {
        return (
            <div className="drivers-list-wrapper">
                <div className={`drivers-header size-l drivers-${this.props.type}`}>
                    <span className="checkbox-wrapper">
                        <input
                            type="checkbox"
                            onChange={() => this.props.updateDriverFilter(this.props.type)}
                            className="checkbox-filter"
                            checked={this.props.statusFilter[this.props.type]}
                        />
                    </span>
                    <span className="drivers-header-title">{this.props.headerTitle}</span>
                    <span className="drivers-total size-s">{this.props.drivers.length}</span>
                </div>
                <ul className="drivers-list"
                    onMouseLeave={event => this.onMouseLeaveDriverList(event)}
                >
                    {this.renderDriverList()}
                </ul>
            </div>
        );
    }


    renderDriverList() {
        if (!this.props.drivers.length) {
            return <div className="no-drivers-message">Sem resultados...</div>;
        }

        return this.props.drivers
            .sort((driver1, driver2) => {
                if (driverUtils.isCloseToStore(driver1) && !driverUtils.isCloseToStore(driver2)) {
                    return -1;
                }

                if (!driverUtils.isCloseToStore(driver1) && driverUtils.isCloseToStore(driver2)) {
                    return 1;
                }

                return driver2.updatedAt - driver1.updatedAt;
            })
            .map(driver =>
                <Driver
                    key={`drivers-list-${driver.id}`}
                    driver={driver}
                    selectedDriver={this.props.selectedDriver}
                    onHighlight={this.onDriverHighlight.bind(this)}
                    onClick={this.onDriverClick.bind(this)}
                />
            );
    }


    /*
     *  Events
     */
    onDriverHighlight(driver, event) {
        this.props.updateHighlightedDriver({ id: driver.id })
    }


    onMouseLeaveDriverList(event) {
        this.props.clearHighlightedDriver()
    }


    onDriverClick(driverId, event) {

    }
}

const mapDispatchToProps = {
    updateHighlightedDriver,
    clearHighlightedDriver,
    updateDriverFilter,
}

export default connect(null, mapDispatchToProps)(DriversList);
